/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CancelLastUserMessageRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/chat_messages.pb'
import {CancelLastUserMessageResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/chat_messages.pb'


export const genericCancelLastUserMessage = (request: CancelLastUserMessageRequest, options?: CashRequestOptions) => post<CancelLastUserMessageRequest, CancelLastUserMessageResponse>("/2.0/cash/generic-cancel-last-user-message", request, {...options, rejectOnError: true })